import * as React from 'react';
export const IcCameraFilter = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.56 13.41c-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59zm4.38-7.32c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18zm-2.95-.1c0-.29-.19-.55-.48-.63-1.33-.38-1.5-.56-1.89-1.89a.654.654 0 00-1.26.01c-.38 1.33-.56 1.5-1.88 1.89-.28.08-.48.34-.48.64s.2.55.48.63c1.33.38 1.51.56 1.89 1.89.08.28.34.47.63.47.29-.01.55-.2.63-.49.38-1.33.56-1.5 1.88-1.89.28-.08.48-.34.48-.63zm10.72 12.3L10.42 9a.996.996 0 10-1.41 1.41l9.29 9.29a.996.996 0 101.41-1.41z'
      fill='currentColor'
    />
  </svg>
);
